import React from "react";
import { CLIENT_SCHEDULE_STAT_ORDER } from "./clientScheduleStatsUtils";

export default function ClientScheduleStatusCards({ stats = [] }) {
  const byType = new Map((stats || []).map((s) => [s.type, s]));

  return (
    <div className="mb-3 min-w-0">
      <div className="grid grid-cols-4 sm:grid-cols-7 gap-1.5">
        {CLIENT_SCHEDULE_STAT_ORDER.map((def) => {
          const stat = byType.get(def.type);
          const value = stat?.value ?? 0;
          const name = stat?.name || def.name;
          return (
            <div
              key={def.type}
              className="flex flex-col items-center justify-center rounded-md px-1 py-1.5 text-center min-w-0"
              style={{ backgroundColor: def.color }}
            >
              <div className="text-base font-bold text-gray-900 leading-none">
                {value}
              </div>
              <div className="text-[9px] font-medium uppercase tracking-wide text-gray-800 leading-tight mt-0.5 line-clamp-2">
                {name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
